// extracted by mini-css-extract-plugin
module.exports = {"errorText":"PrevNextButtonsContainer_errorText__N3y3s","pendingMessage":"PrevNextButtonsContainer_pendingMessage__1vuow","container":"PrevNextButtonsContainer_container__1y8zv"};